<template>
  <div style="height: 100%;">
    <SplitContainer3 style="height: 100%" :layout="12" :split_setting1="0.52">
      <template #main>
        <TableMain name="one table" ref="userRolesTable1" :fields="fields" :title="table_title.title1"
          :show_query_container="true" :show_toolbar_container="true" :show_pagination_container="true"
          :show_date_picker="false" :show_toolbar="true" :show_filter="true" :date_picker_label="date_picker_label"
          :query_button_label="query_lable" :hb_table_class="'hb_user_manage_class1'" :only_text="'仅启用'"
          @only_methods="only_main_methods" @on_query="on_query" @state_change="state_change"
          :show_toolbar_button="[1, 1, 0, 0, 1]" @current_changed="current_changed"
          @on_cell_button_click="on_cell_button_click" :specialExport="true" @specialExport="exportUserPrivileges"
          tableref="f2124753372641e8b06b48a952602337">
          <template #specialExport>
            <el-dropdown-item command="adhoc_report" divided>{{ $t("common.export") }}</el-dropdown-item>
            <el-dropdown-item command="specialExport" divided>{{ $t("common.export_user_privilege")
            }}</el-dropdown-item>
          </template>
          <template #query>
            {{ $t('common.user_name') }}：<el-input size="small" v-model="username" style="width: 120px"></el-input>
          </template>
          <template #toolbar="">
            <el-dropdown class="ml-2" @command="languageChange" size="medium">
              <el-button type="info" plain class="iconfont icon-edit" size="mini">
                {{ $t("common.language") }}&nbsp;<i class="fa fa-caret-down"></i></el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="(item, k) in langList" :divided="item.divided" :command="item.key" :key="k">{{
                  item.label }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-tooltip :content="$t('common.new_user')" placement="top" effect="light">
              <el-button type="info" plain @click="createForm('new')" style="width: 55px"
                class="ml-2 iconfont icon-add-new" size="mini">
              </el-button>
            </el-tooltip>
            <!-- <el-tooltip content="重置密码" placement="top" effect="light">
                <el-button
                  type="info"
                  plain
                  @click="createForm('new')"
                  style="width: 55px"
                  class="ml-2 iconfont icon-add-new"
                  size="mini"
                ></el-button>
              </el-tooltip> -->
          </template>
        </TableMain>
      </template>
      <template #top>
        <TableMain ref="userRolesTable2" :show_query_container="false" :show_date_picker="false" :fields="role_fields"
          :table_height_adjust="9" :title="table_title.title2" :date_picker_label="date_picker_label"
          :query_button_label="query_lable" tableref="125b14d16820431fb41d8e961648168a">
          <template #operation>
            <el-button type="success" size="mini" plain class="iconfont icon-save" @click="saveUserRoles">&nbsp;{{
              $t('common.save') }}</el-button>
          </template>
        </TableMain>
      </template>
      <template #bottom>
        <TableMain ref="userRolesTable3" :fields="privilege_fields" :show_query_container="false"
          :title="table_title.title3" :date_picker_label="date_picker_label" :table_height_adjust="2"
          :show_filter="false" tableref="bf24ce0eedcd47b7a2bc05fd9117121f">
        </TableMain>
      </template>
    </SplitContainer3>
    <BaseModal ref="bvChangePwdModal" :title="$t('common.reset_pwd')" @saveData="changePwd" :width="'20%'">
      <template #modal_content>
        <el-form :model="dataPwdForm" :rules="pwdrules" ref="dataPwdForm" label-width="100px" class="demo-dataForm">
          <el-form-item :label="$t('common.reset_pwd')" prop="password">
            <el-input v-model="dataPwdForm.password" show-password :placeholder="$t('common.input') + $t('common.pwd')"
              auto-complete="new-password"></el-input>
          </el-form-item>
        </el-form>
      </template>
    </BaseModal>
    <!-- 新增修改 -->
    <BaseModal ref="bvModal" :title="$t('modal.' + modal_title)" @saveData="saveData">
      <template #modal_content>
        <el-form :model="dataForm" :rules="rules" ref="dataForm" label-width="100px" class="demo-dataForm">
          <el-form-item :label="$t('common.user_name')" prop="username">
            <el-input v-model="dataForm.username" :placeholder="$t('common.input') + $t('common.user_name')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('common.pwd')" prop="password" v-show="modal_title != 'edite_user'" v-if="false">
            <el-input v-model="dataForm.password" show-password :placeholder="$t('common.input') + $t('common.pwd')"
              auto-complete="new-password">
            </el-input>
          </el-form-item>
          <el-form-item :label="$t('common.confirm_pwd')" prop="repassword" v-show="modal_title != 'edite_user'"
            v-if="false">
            <el-input v-model="dataForm.repassword" show-password auto-complete="new-password"
              :placeholder="$t('common.input') + $t('common.confirm_pwd')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('common.real_name')" prop="realname">
            <el-input v-model="dataForm.realname" :placeholder="$t('common.input') + $t('common.real_name')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('common.email')" prop="email">
            <el-input v-model="dataForm.email" :placeholder="$t('common.input') + $t('common.email')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('common.department')" prop="department">
            <el-input v-model="dataForm.department"
              :placeholder="$t('common.input') + $t('common.department')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('common.description')" prop="description">
            <el-input v-model="dataForm.description" :placeholder="$t('common.input') + $t('common.description')"
              type="textarea" rows="3">
            </el-input>
          </el-form-item>
          <el-form-item :label="$t('common.valid')" prop="is_valid">
            <el-checkbox v-model="dataForm.is_valid"></el-checkbox>
          </el-form-item>
          <el-form-item :label="$t('common.domain_user')" prop="" v-show="false">
            <el-checkbox v-model="dataForm.isDomainUser"></el-checkbox>
          </el-form-item>
          <el-form-item :label="$t('common.internal_user')" prop="isInternal">
            <el-checkbox v-model="dataForm.isInternal"></el-checkbox>
          </el-form-item>
          <el-form-item :label="$t('common.bind_cust_all')" prop="is_Include_All">
            <el-checkbox v-model="dataForm.is_Include_All"></el-checkbox>
          </el-form-item>
        </el-form>
      </template>
    </BaseModal>
  </div>
</template>

<script>
// -- import * as _ from "lodash-es"
import * as PropertyManageController from "../../controllers/system/PropertyManageController"
import * as RoleManageController from "../../controllers/system/RoleManageController"
import * as RolePropertyManageController from "../../controllers/system/RolePropertyManageController"
import * as UserManageController from "../../controllers/system/UserManageController"
import SplitContainer3 from "../components/container/SplitContainer3"
import BaseModal from "../components/modals/baseModal"
import TableMain from "../components/table/TableMain"

export default {
  name: "UserManage",
  components: {
    TableMain,
    BaseModal,
    SplitContainer3,
  },
  data() {
    return {
      date_picker_label: "common.search",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "table_user",
        title2: "table_user_role",
        title3: "table_user_property",
      },
      langList: [
        { key: "zh-CN", label: "中文(Chinese)", divided: false },
        { key: "en", label: "英语(English)", divided: true },
      ],
      modal_title: "create_user",
      fields: UserManageController.fields,
      role_fields: _.cloneDeep(RoleManageController.fields),
      privilege_fields: _.cloneDeep(PropertyManageController.fields),
      dataForm: _.cloneDeep(UserManageController.dataForm),
      dataPwdForm: _.cloneDeep(UserManageController.dataPwdForm),
      rules: UserManageController.rules,
      pwdrules: UserManageController.pwdrules,
      username: "",
      current_user: null,
      userRoleChecked: false,
      all_roles: [],
      user_roles: [],
      only_valid: false
    }
  },
  created() {
    _.find(this.role_fields, { key: "id" }).type = ""
    _.find(this.privilege_fields, { key: "id" }).type = ""
    this.privilege_fields.splice(1, 0, { key: "role_code", label: "角色编码" })
  },
  methods: {
    async exportUserPrivileges() {
      let loading = null
      let _this = this
      loading = this.$loading({
        lock: true,
        text: this.$t("notify.loading"),
        background: "rgba(0, 0, 0, 0.7)",
      })
      let userIds = []
      if (this.$refs.userRolesTable1.my_data.length < 1) {
        loading.close()
        this.msgToasts(this.$t("notify.not_data"), "info")

        return
      }
      _.each(this.$refs.userRolesTable1.my_data, (t) => {
        userIds.push(t.id)
      })
      let selected_items = []
      let dataList =
        await RolePropertyManageController.methods.GetAllUserPrivileges(
          userIds
        )

      _.each(dataList, (t) => {
        _.each(t.result.data.Result, (y) => {
          selected_items.push(y)
        })
      })
      _.each(selected_items, (t) => {
        let userinfo = _.find(this.$refs.userRolesTable1.my_data, {
          id: t.userId,
        })
        t.username = userinfo.username
        t.realname = userinfo.realname
        t.email = userinfo.email
        t.department = userinfo.department
        t.description = userinfo.description
        t.user_is_valid = userinfo.is_valid
      })


      if (selected_items.length < 1) {
        loading.close()
        _this.msgToasts(this.$t("notify.not_selected_data"), "warning")
        return
      }

      require.ensure([], () => {
        const { export_json_to_excel } = require("../../shared/Export2Excel")
        const tHeader = []
        const filterVal = []
        let my_fields = UserManageController.export_fields
        for (var i in my_fields) {
          //过滤首列
          if (my_fields[i].key != "_selected") {
            tHeader.push(my_fields[i].label)
            filterVal.push(my_fields[i].key)
          }
        }
        const list = selected_items

        const data = list.map((v) => filterVal.map((j) => v[j]))
        var numReg = /^[0-9]*$/
        var numRe = new RegExp(numReg)
        for (var index = 0; index < data.length; index++) {
          for (var j in data[index]) {
            if (data[index][j] == true && !numRe.test(data[index][j])) {
              data[index][j] = "√"
            }
            if (data[index][j] == false && !numRe.test(data[index][j])) {
              data[index][j] = ""
            }
          }
        }

        export_json_to_excel(tHeader, data, "用户权限列表", "", loading)
      })
    },
    on_cell_button_click(data) {
      let _data = data.item
      this.dataForm = _.cloneDeep(_data)

      if (data.field.key != "changePWD") {
        this.createForm("edit")
      } else {
        if (_data.isDomainUser) {
          this.msgToasts(this.$t("notify.area_user_can_not_reset_pwd"), "info")
          return
        } else {
          this.createChange()
        }
      }
    },
    //#region 查询
    ///获取用户
    async on_query(set_data) {
      let _this = this
      // let _result = await UserManageController.methods.getData();
      let rt = await UserManageController.methods.getUserLanguage()
      let _result = rt ? rt[0] : []
      if (!_.isEmpty(this.username)) {
        _result = _.filter(_result, (t) => {
          return t.username.indexOf(_this.username) > -1
        })
      }
      _result = _.filter(_result, (t) => {
        if (this.only_valid) {
          return !t.is_deleted && t.is_valid
        }
        return !t.is_deleted
      })
      if (_result && _result.length > 0) {
        set_data(_.orderBy(_result, ["id"], ["asc"]))
      } else {
        set_data([])
      }
      //获取所有角色
      if (this.$refs.userRolesTable1.my_data.length > 0) {
        let _result_all_role = await RoleManageController.methods.GetRoleList()
        if (_result_all_role && _result_all_role.length > 0) {
          this.$refs.userRolesTable2.SetData(
            _.orderBy(_result_all_role, ["id"], ["asc"])
          )
          this.all_roles = _result_all_role
        }
      }
    },
    only_main_methods(only_value) {
      this.only_valid = only_value
      this.on_query(this.$refs.userRolesTable1.SetData)
    },
    ///获取用户角色及权限
    async current_changed(old, current) {
      if (current) {
        this.current_user = current

        //获取用户角色
        let _result_role = await UserManageController.methods.getUserRoles(
          current.id
        )
        if (_result_role && _result_role.length > 0) {
          this.$refs.userRolesTable2.setSelect(_result_role)
          this.user_roles = _result_role
        } else {
          this.$refs.userRolesTable2.setSelect([])
          this.user_roles = []
        }

        //获取权限
        let _result_privilege =
          await UserManageController.methods.getUserPrivilege(current.id)
        if (_result_privilege && _result_privilege.length > 0) {
          this.$refs.userRolesTable3.SetData(
            _.orderBy(_result_privilege, ["id"], ["asc"])
          )
        } else {
          this.$refs.userRolesTable3.SetData([])
        }
      }
    },
    async Table2_current_changed(old, current) {

      let _this = this
      let _dt = await RoleManageController.methods.GetRoleOwnPrivilege(
        current.id
      )
      if (_dt) {
        _this.$refs.userRolesTable3.SetData(_dt)
      } else {
        _this.$refs.userRolesTable3.SetData([])
      }
    },

    //#endregion

    //#region 保存
    createChange() {
      this.$refs.bvChangePwdModal.show()
    },
    ///初始化编辑界面
    createForm(code) {
      let title = ""
      switch (code) {
        case "new":
          title = "create_user"
          this.dataForm = _.cloneDeep(UserManageController.dataForm)
          break
        case "edit":
          title = "edite_user"
          break
      }
      this.modal_title = title
      this.$refs.bvModal.show()
    },
    async changePwd(cb) {
      let _this = this
      this.dataPwdForm.id = this.dataForm.id
      this.$refs.dataPwdForm.validate(async (valid) => {
        if (valid) {
          let _result = await UserManageController.methods.resetPwd(
            _this.dataPwdForm
          )

          if (!_.isNull(_result)) {
            if (_result.Success) {
              this.msgToasts(this.$t("notify.pwd_reset_success"), "success")

              cb(true, true)
            } else {
              this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
              cb(false)
            }
          } else {
            //失败
            this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
            cb(false)
          }
        } else {
          this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
          cb(false)
        }
      })
    },
    ///新增修改用户信息
    async saveData(cb) {
      let _this = this
      this.$refs.dataForm.validate(async (valid) => {
        if (valid) {
          //邮箱验证
          var regEmail =
            /^[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*\.[a-z]{2,}$/
          if (
            this.dataForm.email != "" &&
            !regEmail.test(this.dataForm.email)
          ) {
            this.msgToasts(this.$t("notify.email_error"), "error")
            this.dataForm.email
            cb(false)
            return
          }
          console.log(this.dataForm.id)
          if (this.dataForm.id == "") {
            //密码重复性检查
            if (_this.dataForm.password != _this.dataForm.repassword) {
              _this.msgToasts(this.$t("notify.confirm_pwd_error"), "error")
              cb(false)
              return false
            }

            ///保存数据
            let _result = await UserManageController.methods.saveData(
              this.dataForm
            )

            if (!_.isNull(_result)) {
              if (_result.exists) {
                this.msgToasts(this.$t("notify.user_not_existe"), "error")
                cb(false)
                return
              } else {
                let data = {}
                data.id = _result.id
                data.username = this.dataForm.username
                data.password = this.dataForm.password
                data.realname = this.dataForm.realname
                data.email = this.dataForm.email
                data.department = this.dataForm.department
                data.description = this.dataForm.description
                data.is_valid = this.dataForm.is_valid
                data.isDomainUser = true
                data.is_Include_All = this.dataForm.is_Include_All
                this.$refs.userRolesTable1.AppendItems([data])
                //新增客户的默认权限
                await UserManageController.methods.insertDefaultRole(
                  _result.id
                )

                cb(true, true)
              }
            } else {
              //失败
              cb(false)
            }
          } else {
            if (this.dataForm.id == "") {
              cb(false)
              return false
            } else {
              let _result = await UserManageController.methods.saveData(
                this.dataForm
              )

              if (!_.isNull(_result)) {
                if (_result.exists) {
                  this.msgToasts(this.$t("notify.user_not_existe"), "error")
                  cb(false)
                  return
                } else {
                  this.$refs.userRolesTable1.UpdateItems(
                    { id: this.dataForm.id },
                    this.dataForm
                  )

                  cb(true, true)
                }
              } else {
                //失败
                cb(false)
              }
            }
          }
        }
      })
    },
    ///编辑用户角色
    async saveUserRoles() {
      let _this = this
      if (_.isNull(this.current_user) || _.isNull(this.current_user.id)) {
        this.msgToasts(this.$t("notify.not_selected_user"), "warning")
        return false
      }
      let only_selected_items = _.filter(
        this.$refs.userRolesTable2.my_data,
        (d) => d._selected
      )
      ///add user roles
      let _add_items = []
      if (_this.user_roles.length > 0) {
        _.each(only_selected_items, (t) => {
          let _index = _.findIndex(_this.user_roles, { id: t.id })
          if (_index < 0) {
            _add_items.push(_.cloneDeep(t))
          }
        })
      } else {
        _add_items = only_selected_items
      }

      ///remove user roles
      let _remove_items = []
      _.each(_this.user_roles, (t) => {
        let _index = _.findIndex(only_selected_items, { id: t.id })
        if (_index < 0) {
          _remove_items.push(_.cloneDeep(t))
        }
      })
      if (_add_items.length > 0 || _remove_items.length > 0) {
        let _result = await UserManageController.methods.updateUserRoles(
          _add_items,
          _remove_items,
          this.current_user.id
        )
        if (!_.isNull(_result)) {
          if (_result && _result.Success) {
            this.msgToasts(this.$t("notify.action_successfully"), "success")
            //刷新
            //获取权限
            let _result_privilege =
              await UserManageController.methods.getUserPrivilege(
                this.current_user.id
              )
            if (_result_privilege && _result_privilege.length > 0) {
              this.$refs.userRolesTable3.SetData(
                _.orderBy(_result_privilege, ["id"], ["asc"])
              )
            } else {
              this.$refs.userRolesTable3.SetData([])
            }

            let _result_role = await UserManageController.methods.getUserRoles(
              this.current_user.id
            )
            if (_result_role && _result_role.length > 0) {
              this.$refs.userRolesTable2.setSelect(_result_role)
              this.user_roles = _result_role
            } else {
              this.$refs.userRolesTable2.setSelect([])
              this.user_roles = []
            }
          } else {
            this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
          }
        }
      }
    },
    //#endregion

    //#region 状态切换
    async state_change(data, cb) {
      if (data) {
        if (data.selected_items.length > 0) {
          let _userIds = []
          _.each(data.selected_items, (t) => {
            _userIds.push(t.id)
          })
          ///启用
          if (data.state === "valid") {
            let _result = await UserManageController.methods.activeUsers(
              _userIds
            )
            if (!_.isNull(_result)) {
              if (_result && _result.Success) {
                _.each(_userIds, (t) => {
                  let _m = _.find(this.$refs.userRolesTable1.my_data, {
                    id: t,
                  })
                  if (_m) {
                    _m.is_valid = true
                  }
                })

                this.msgToasts(this.$t("notify.action_successfully"), "success")
                cb(true, true)
              } else {
                this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
                cb(false)
              }
            } else {
              cb(false)
            }
          }
          ///禁用
          else if (data.state === "invalid") {
            let _result = await UserManageController.methods.blockUsers(
              _userIds
            )
            if (!_.isNull(_result)) {
              if (_result && _result.Success) {
                _.each(_userIds, (t) => {
                  let _m = _.find(this.$refs.userRolesTable1.my_data, {
                    id: t,
                  })
                  if (_m) {
                    _m.is_valid = false
                  }
                })
                this.msgToasts(this.$t("notify.action_successfully"), "success")
                cb(true, true)
              } else {
                this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
                cb(false)
              }
            } else {
              cb(false)
            }
          } else if (data.state === "deleted") {
            let _result = await UserManageController.methods.deleteUser(
              _userIds
            )
            if (_result) {
              this.msgToasts(this.$t("notify.action_successfully"), "success")
              //删除本行
              this.$refs.userRolesTable1.RemoveItems(data.selected_items)
              cb(true)
            } else {
              this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
              cb(false)
            }
          }
        }
      }
    },
    async languageChange(state) {
      let select_items = this.$refs.userRolesTable1.GetSelectedItems()
      if (select_items == 0) {
        this.msgToasts(this.$t("notify.not_selected_data"), "info")
        return
      }
      let dt = []
      _.each(select_items, async (t) => {
        t.language_code = state
        dt.push({ id: t.id, language_code: t.language_code })
      })
      let _result = await UserManageController.methods.updateUserLang(dt)
      if (_result) {
        this.msgToasts(this.$t("notify.action_successfully"), "success")
      }
      else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
      }

    },
    //#endregion
  },
}
</script>
<style>
.hb_user_manage_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 80rem;
}
</style>
